import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const privacy = {
  namespaced: true,
  state: {
    agreedToPrivacy: false,
    config: null,
    snackbar: false
  },
  getters,
  mutations,
  actions
};
